const routes = [
  {
    path: '/system',
    name: '系统管理',
    component: () => import('@/pages/Layout'),
    redirect: '/user/to',
    children: [
      // 用户管理
      { path: '/user/to', name: 'User', meta: { keepAlive: true, title: '用户管理' }, component: () => import('@/pages/sys/User') },
      { path: '/user/add', meta: { title: '新增用户' }, component: () => import('@/pages/sys/actions/UserAdd') },
      { path: '/user/info/:id', meta: { title: '用户详情' }, props: true, component: () => import('@/pages/sys/actions/UserInfo') },
      // 角色管理
      { path: '/role/to', name: 'Role', meta: { keepAlive: true, title: '角色管理' }, component: () => import('@/pages/sys/Role') },
      { path: '/role/add', meta: { title: '新增角色' }, component: () => import('@/pages/sys/actions/RoleAdd') },
      { path: '/role/info/:id', props: true, meta: { title: '角色详情' }, component: () => import('@/pages/sys/actions/RoleInfo') },
      // 角色管理
      { path: '/dict/to', name: 'Dict', meta: { keepAlive: true, title: '分类码管理' }, component: () => import('@/pages/sys/Dict') },
      { path: '/dict/add', meta: { title: '新增分类码' }, component: () => import('@/pages/sys/actions/DictAdd') },
      { path: '/dict/edit/:id', meta: { title: '修改分类码' }, component: () => import('@/pages/sys/actions/DictAdd') },
      { path: '/dict/info/:id', props: true, meta: { title: '分类码详情' }, component: () => import('@/pages/sys/actions/DictInfo') }
    ]
  },
  {
    path: '/log',
    name: '日志管理',
    component: () => import('@/pages/Layout'),
    redirect: '/loginLog/to',
    children: [
      // 日志管理
      { path: '/loginLog/to', name: 'LogLogin', meta: { keepAlive: true, title: '登录日志查询' }, component: () => import('@/pages/sys/LogLogin') },
      { path: '/userLog/to', name: 'LogUser', meta: { keepAlive: true, title: '操作日志查询' }, component: () => import('@/pages/sys/LogUser') }
    ]
  },
  {
    path: '/electricityFees',
    name: '基础参数维护',
    component: () => import('@/pages/Layout'),
    redirect: '/electricityFees/to',
    children: [
      { path: '/electricityFees/to', name: 'ElectricityFees', meta: { keepAlive: true, title: '电费设置' }, component: () => import('@/pages/price/Price') },
      { path: '/electricityFees/add', name: 'ElectricityFeesAdd', meta: { flag: 'add' }, component: () => import('@/pages/price/actions/PriceAdd') },
      { path: '/electricityFees/info/:id', props: true, name: 'ElectricityFeesInfo', meta: { flag: 'info' }, component: () => import('@/pages/price/actions/PriceInfo') },
      { path: '/electricityFees/edit/:id', name: 'ElectricityFeesEdit', meta: { flag: 'edit' }, component: () => import('@/pages/price/actions/PriceAdd') },
      { path: '/quote/to', name: 'Quote', meta: { keepAlive: true, title: '每日行情' }, component: () => import('@/pages/price/Quote') },
      { path: '/exrate/to', name: 'Exrate', meta: { keepAlive: true, title: '汇率设置' }, component: () => import('@/pages/price/Exrate') }
    ]
  },
  {
    path: '/income',
    name: '收益管理',
    component: () => import('@/pages/Layout'),
    redirect: '/poolIncome/to',
    children: [
      { path: '/poolIncome/to', name: 'PoolIncome', meta: { keepAlive: true, title: '矿池每天收益录入' }, component: () => import('@/pages/income/PoolIncome') },
      { path: '/custIncome/to', name: 'CustIncome', meta: { keepAlive: true, title: '收益分配记录查询' }, component: () => import('@/pages/income/CustIncome') },
      { path: '/withdraw/to', name: 'Withdraw', meta: { keepAlive: true, title: '客户收益提现' }, component: () => import('@/pages/income/Withdraw') },
      { path: '/rent/to', name: 'Rent', meta: { keepAlive: true, title: '租金分配管理' }, component: () => import('@/pages/income/Rent') },
      { path: '/elecFeesAccrual/to', name: 'ElecFee', meta: { keepAlive: true, title: '电费计提' }, component: () => import('@/pages/income/ElecFee') }
    ]
  },
  {
    path: '/',
    component: () => import('@/pages/Layout'),
    children: [
      { path: '', component: () => import('@/pages/Home') },
      { path: '/news/to', name: 'News', meta: { keepAlive: true, title: '消息发布' }, component: () => import('@/pages/news/News') },
      { path: '/news/add', name: 'NewsAdd', component: () => import('@/pages/news/actions/NewsAdd') },
      { path: '/news/info/:id', props: true, name: 'NewsInfo', component: () => import('@/pages/news/actions/NewsInfo') },
      { path: '/news/edit/:id', props: true, name: 'NewsEdit', component: () => import('@/pages/news/actions/NewsAdd') },
      { path: '/cust/to', name: 'Cust', meta: { keepAlive: true, title: '客户管理' }, component: () => import('@/pages/cust/Cust') },
      { path: '/cust/add', name: 'CustAdd', meta: { flag: 'add' }, component: () => import('@/pages/cust/actions/CustAdd') },
      { path: '/cust/info/:id', props: true, meta: { flag: 'info' }, name: 'CustInfo', component: () => import('@/pages/cust/actions/CustInfo') },
      { path: '/cust/edit/:id', props: true, meta: { flag: 'edit' }, name: 'CustEdit', component: () => import('@/pages/cust/actions/CustAdd') },
      { path: '/machine/to', name: 'Device', meta: { keepAlive: true, title: '设备管理' }, component: () => import('@/pages/mc/Device') },
      { path: '/machine/add', name: 'DeviceAdd', component: () => import('@/pages/mc/actions/DeviceAdd') },
      { path: '/machine/info/:id', props: true, name: 'DeviceInfo', component: () => import('@/pages/mc/actions/DeviceInfo') },
      { path: '/machine/edit/:id', props: true, name: 'DeviceEdit', component: () => import('@/pages/mc/actions/DeviceAdd') },
      { path: '/parts/to', name: 'Parts', meta: { keepAlive: true, title: '备件管理' }, component: () => import('@/pages/parts/Parts') },
      { path: '/parts/info/:partCode/:location/:siteCode', props: true, name: 'PartsInfo', component: () => import('@/pages/parts/actions/PartsInfo') }
    ]
  },
  // {
  //   path: '/',
  //   component: () => import('@/pages/Layout'),
  //   children: [
  //     { path: '', component: () => import('@/pages/Home') },
  //     // 用户管理
  //     { path: 'user/to', name: 'User', meta: {keepAlive: true}, component: () => import('@/pages/sys/User') },
  //     { path: 'user/add', component: () => import('@/pages/sys/actions/UserAdd') },
  //     { path: 'user/info/:id', props: true, component: () => import('@/pages/sys/actions/UserInfo') },
  //     // 角色管理
  //     { path: 'role/to', name: 'Role', meta: {keepAlive: true}, component: () => import('@/pages/sys/Role') },
  //     { path: 'role/add', component: () => import('@/pages/sys/actions/RoleAdd') },
  //     { path: 'role/info/:id', props: true, component: () => import('@/pages/sys/actions/RoleInfo') },
  //     // 日志管理
  //     { path: 'loginLog/to', name: 'LogLogin', meta: {keepAlive: true}, component: () => import('@/pages/sys/LogLogin') },
  //     { path: 'userLog/to', name: 'LogUser', meta: {keepAlive: true}, component: () => import('@/pages/sys/LogUser') }
  //   ]
  // },
  { path: '/login', component: () => import('@/pages/Login') },
  { path: '/modPW', component: () => import('@/pages/ModPW') },
  { path: '/forgetPwd', component: () => import('@/pages/forgetPwd') }

]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js